var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningFilled = function SvgWarningFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.71 11.97-6-10a2 2 0 0 0-3.43 0l-6 10A2 2 0 0 0 2 15h12a2 2 0 0 0 1.71-3.03ZM8 13a1 1 0 1 1 0-2.001A1 1 0 0 1 8 13Zm1-4a1 1 0 0 1-2 0V5a1 1 0 0 1 2 0v4Z"
  })));
};
export default SvgWarningFilled;